import { Time } from "@angular/common";

export class MergeLessonSummaryRequest {
    sessionId: number;
    tutorId: number;
    placementId: number;
    subject: string;
    lessonSummary: string;
    lessonType: string;
    startDate: Date;
    startTime: Time;
    endTime: Time;
    statusDescription: string;
    studentDetails: MergeLessonSummaryStudentDetails[];
}

export class MergeLessonSummaryStudentDetails
{
    id: number;
    studentId: number;
    studentName: string;
    attendance: string;
    engagement?: number;
    comprehension?: number;
    reasonDescription: string;
    learnerComments: string;
    studentProgression: StudentProgression;
}

export class StudentProgression {
    studentId: number;
    lastTarget: string;
    currentProgress: string;
    assessmentScore: string;
}
